import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { PLANS } from 'services/config'

import { Button, IonIcon } from 'controls'
import Auth from 'components/Auth/AuthByRoles'
import { Tooltip } from 'components'

import { teamAssistantInfoRemainderStyles } from './styles'

const TeamAssistantInfoRemainder = ({ children }) => {
  const isOpenTeamRemainder = useSelector(state =>
    Boolean(state.auth?.teamAssistant?.isOpenTeamRemainder),
  )
  const [closedByUser, setClosedByUser] = useState(false)

  useEffect(() => {
    if (closedByUser) 
      setVisible(false)
  }, [closedByUser])

  const [visible, setVisible] = useState(isOpenTeamRemainder)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 7500)
    setVisible(isOpenTeamRemainder)

    return () => clearTimeout(timer)
  }, [isOpenTeamRemainder])

  const tooltipContent = visible ? (
    <div className="tooltip-content">
      <h3 className="title">
        <IonIcon size="large" icon="md-help-buoy" className="hideOnMobile" />
        Contactanos
        <div className="close-icon">
          <IonIcon
            size="small"
            className="close-icon"
            onClick={() => setClosedByUser(true)}
            icon="md-close"
          />
        </div>
      </h3>
      <p>
        Recuerda que tienes un gran equipo que siempre está listo para ayudarte
      </p>
      <Button href="/dashboard/team-assistant" color="primary">
        Conoce tu Equipo
      </Button>

      <style jsx>{teamAssistantInfoRemainderStyles}</style>
    </div>
  ) : null

  return (
    <Auth
      roles={['BROKER']}
      plans={[PLANS.FULL_SERVICE, PLANS.IN_HOUSE_FULL, PLANS.AFFILIATE]}
    >
      <Tooltip
        isOpen={isOpenTeamRemainder}
        initialTooltipAlign="left"
        tooltipContent={tooltipContent}
      >
        {children}
      </Tooltip>
    </Auth>
  )
}

export default TeamAssistantInfoRemainder
